module.exports = __webpack_public_path__ + "static/media/rectangle-dsktp-logged-out.c37d3ac3.png";